import React from 'react';
export function UrgencyBanner() {
  return <div className="bg-brand-forest text-white py-2 px-4 text-center" data-id="element-186">
      <p className="text-xs sm:text-sm font-bold uppercase tracking-wide" data-id="element-187">
        ⚡ OFERTA DE LANZAMIENTO: 50% DE DESCUENTO DISPONIBLE SOLO POR HOY
      </p>
    </div>;
}